import Axios from "axios";
import { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";

/**
 * این کامپوننت برای نمایش مدال ارسال پیامک گروهی است
 */
const SendSmsModal = ({ handelCloseModal, show, dataform, handelrelod }) => {

    const { urldashboard, authentication, handelerrors } = useContext(DashboardContext);

    const [loading, setLoading] = useState(false);

    const handelSendData = async () => {
        setLoading(true)
        try {
            const res = await Axios.post(`${urldashboard}/accountbalance/sendmessage`,
                JSON.stringify( {workerIds: [...dataform]} ),
                {
                    headers: {
                        "Authorization": authentication,
                        "content-type": "application/json; charset=utf-8"
                    }
                })
            const data = await res.data
            handelCloseModal();
            handelrelod();
            setLoading(false)
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            setLoading(false)
            handelerrors(error)

        }
    }


    return (
        <Modal show={show} onHide={handelCloseModal} >
            <Modal.Header>
                <Modal.Title>ارسال پیامک گروهی</Modal.Title>
                <i className="fa fa-times mr-auto" style={{ fontSize: '16px', cursor: 'pointer' }}
                    onClick={handelCloseModal} aria-hidden="true"></i>
            </Modal.Header>
            <Modal.Body>
                <p>آیا از ارسال پیامک مطمئن هستید؟</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={loading} onClick={handelCloseModal} >خیر</Button>
                <Button variant="success" disabled={loading} onClick={handelSendData} >
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "بله"
                    }
                </Button>

            </Modal.Footer>
        </Modal>
    );
}

export default SendSmsModal;
